import { render, staticRenderFns } from "./income_expense.vue?vue&type=template&id=2e20caec&"
import script from "./income_expense.vue?vue&type=script&lang=js&"
export * from "./income_expense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports